import { Unidade } from "./unidade.model";

export class Usuario {
  id = 0;
  login?: string = null;
  email: string = null;
  senha: string = null;
  ativo: boolean = null;
  dtInclusao?: Date = null;
  dtAlteracao?: Date = null;
  tb_usuario_perfil?: [{
    usuarioId: number;
    perfilId: number;
    tb_perfil?: [{
      nome: string;
    }]
  }]
  unidadeId?: number;
  unidade?: Unidade
}

export class UsuarioDialog {
  id = 0;
  login?: string = null;
  email: string = null;
  senha: string = null;
  ativo: boolean = null;
  dtInclusao?: Date = null;
  dtAlteracao?: Date = null;
  perfilId: number;
  unidadeId: number;
}